import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { CalendarToday, Restore } from "@mui/icons-material";

const OutageFormSubmitButton: React.FC<IOutageFormSubmitButton> = ({ content, click, fontSize = 16, inserting, disabled = false, restore = false }) => {
    return (
        <Box
            sx={{ height: "100%" }}>
            <Button
                variant="contained"
                disabled={disabled}
                onClick={click}
                fullWidth
                sx={{ height: "100%", fontSize: fontSize }}
            >
                {inserting ? <CircularProgress
                    size={fontSize}
                /> : restore ? <><Restore/>&nbsp;{content}</>: <><CalendarToday fontSize="inherit" />&nbsp;{content}</>}
            </Button>
        </Box>
    );
}
export interface IOutageFormSubmitButton {
    content: string
    click: () => void
    fontSize?: string|number
    inserting?: boolean
    disabled?: boolean
    restore?: boolean
}

export default OutageFormSubmitButton;